class Alertbar {
    cookieName = 'closeAlert';

    constructor(element) {
        this.element = element;
        this.setHtmlCssClassMarketBarBottom(element);

        document.querySelector('html').classList.add('notification-bar--not-visible');
        if (!element) {
            return;
        }
        this.header = document.querySelector('.header');

        if (this.getShouldHide()) {
            element.style.display = 'none';
            return;
        }

        document.querySelector('html').classList.remove('notification-bar--not-visible');
        document.body.classList.add('notification-bar--visible');
        document.querySelector('html').classList.add('notification-bar--visible');

        this.setHeaderCssTop();

        let timer;
        const onResize = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                this.setHeaderCssTop();
            }, 200);
        }
        window.addEventListener('resize', onResize.bind(this), { passive: true });

        element.querySelector('.alertbar-close').addEventListener('click', this.onCloseBarClick);
    }

    setHeaderCssTop = () => {
        let bannerHeight = 0;

        if (this.element.clientHeight) {
            bannerHeight += this.element.clientHeight;
            this.header.style.top = `${bannerHeight}px`;
        }
    }

    setHtmlCssClassMarketBarBottom = (element) => {
        if (element) {
            const marketSelectorDropdown = document.querySelector('.new-market-seletor .new-dropdown__list');
            if (marketSelectorDropdown !== null) {
                marketSelectorDropdown.classList.add('new-dropdown__list--from-bottom')
            } else {
                const hasQueryStringForApp = document.location.search.indexOf('app=1') !== -1;
                const isPartnerPage = document.querySelector('.header--partner') !== null;
                const hasHideCookie = document.cookie.split('marketSelect=').length > 1;
                if (!hasQueryStringForApp && !isPartnerPage && !hasHideCookie) {
                    console.warn('unexpected missing market dropdown!');
                }
            }
        }
    }

    getCookieValue = () => {
        const parts = document.cookie.split(`${this.cookieName}=`);
        if (parts.length <= 1) {
            return null;
        }
        return JSON.parse(decodeURIComponent(parts[1].split(';')[0]));
    }

    getShouldHide = () => {
        const cookieValue = this.getCookieValue();
        if (!cookieValue) {
            return false;
        }
        return cookieValue.ids.includes(this.element.id);
    }

    onCloseBarClick = () => {
        let ids = [this.element.id];
        const cookieValue = this.getCookieValue();
        if (cookieValue?.ids) {
            ids = [...ids, ...cookieValue.ids];
        }

        const value = encodeURIComponent(JSON.stringify({
            ids: ids,
        }));
        document.cookie = `${this.cookieName}=${value}; path=/;`;
        this.element.style.position = 'fixed';
        this.element.style.top = '';
        this.element.parentNode.style.height = '';
        this.element.classList.add('alertbar-hide');
        this.header.style.transition = 'top 0.6s ease 0s';
        this.header.style.top = '';
        document.querySelector('html').classList.remove('notification-bar--visible');
        document.body.classList.remove('notification-bar--visible');

        const marketSelectorDropdown = document.querySelector('.new-market-seletor .new-dropdown__list');
        if (marketSelectorDropdown !== null) {
            marketSelectorDropdown.classList.remove('new-dropdown__list--from-bottom')
        }
    }
}
// export default () => {
new Alertbar(document.querySelector('.alertbar'));
// };



/* @todo refactor or remove (if old euro-yellow alertbar is never used like predicted?) below to something more readable ==> */

const notificationBar = document.querySelector('.notification-bar-section');
const header = document.querySelector('.header');

export const setHeaderCssTop = () => {
    if (notificationBar === null) {
        return;
    }
    let bannerHeight = 0;

    if (notificationBar.clientHeight) {
        bannerHeight += notificationBar.clientHeight;
        header.style.top = `${bannerHeight}px`;
    }
}

const positionBar = () => {
    requestAnimationFrame(setHeaderCssTop);
}

const events = () => {
    setHeaderCssTop();

    window.addEventListener('resize', positionBar, { passive: true });

    const continueBtn = document.querySelector('.new-market-seletor__btn');
    if (continueBtn) {
        let thisUpdateHeight = setHeaderCssTop.bind(this);
        continueBtn.addEventListener('click', () => {
            setTimeout(() => {
                thisUpdateHeight();
            }, 10);
        });
    }
}

const init = () => {
    if (notificationBar !== null) {
        document.body.classList.add('notification-bar--visible');
        document.querySelector('html').classList.add('notification-bar--visible');

        const marketSelectorDropdown = document.querySelector('.new-market-seletor .new-dropdown__list');
        if (marketSelectorDropdown !== null) {
            marketSelectorDropdown.classList.add('new-dropdown__list--from-bottom')
        } else {
            const hasQueryStringForApp = document.location.search.indexOf('app=1') !== -1;
            const isPartnerPage = document.querySelector('.header--partner') !== null;
            if (!hasQueryStringForApp && !isPartnerPage) {
                console.warn('unexpected missing market dropdown!');
            }
        }
    } else {
        if (document.querySelector('.alertbar') === null) {
            document.querySelector('html').classList.add('notification-bar--not-visible');
        }
    }

    if (header === null || notificationBar === null) {
        return;
    }
    events();
}

export default init;